import { API } from '@shared/types/api';
import { MBStackedUsers } from '../message/stackedUsers';

export interface SeenByImagesProps {
  users: API.ShortUserFragment[];
  isCountVisible?: boolean;
}

export function SeenByImages({ users, isCountVisible }: SeenByImagesProps) {
  return <MBStackedUsers users={users} small isCountVisible={isCountVisible} />;
}
